import type { ShellNode } from '@vedalib/editor'
import type { EditorElement } from '@vedalib/editor/lib/elements'

import { ELEMENTS_CONFIG } from 'components/Editor/EditorElements/elements.config'
import type { Block } from 'services/Store/Project/types'
import { t } from 'services/Translation'

import { getElement, getNode } from './block'

export const getElementName = (element: EditorElement) =>
  ELEMENTS_CONFIG[element?.type]?.label || t('common.empty')

export const getShellName = (block: Pick<Block, 'schema' | 'elements'>, id: string) => {
  const shell = getNode(block, id) as ShellNode
  return shell?.name || getElementName(getElement(block, shell?.elementId || ''))
}
